import { TourConfig } from './tourTypes';
import { canappsNavigationTour } from './tours/canappsNavigation';
import { canparkManageSitesTour } from './tours/canparkManageSites';
import { canparkMonitorSiteTour } from './tours/canparkMonitorSite';
import { canparkRegisterPlateTour } from './tours/canparkRegisterPlate';
import { canmeetInstantTour, canmeetScheduledTour } from './tours/canmeetMeetings';
import { canparkTicketingTour } from './tours/canparkTicketing';
import { canappsAddUserTour } from './tours/canappsAddUser';

// Re-export the shared type + each tour's step-index constants so existing
// consumers (the sync hooks, TourGuard, etc.) keep importing them from here.
export type { TourConfig } from './tourTypes';
export { CANAPPS_HOME_STEP } from './tours/canappsNavigation';
export { MANAGE_SITES_STEP } from './tours/canparkManageSites';
export { CANPARK_MONITOR_STEP } from './tours/canparkMonitorSite';
export { REGISTER_PLATE_STEP } from './tours/canparkRegisterPlate';
export { CANMEET_INSTANT_STEP, CANMEET_SCHEDULED_STEP } from './tours/canmeetMeetings';
export { CANPARK_TICKET_STEP, CANPARK_STAGE_RANGE } from './tours/canparkTicketing';
export { ADD_USER_STEP } from './tours/canappsAddUser';

// The registry of launchable tours, keyed by tour_key (matches the DB `tours`
// row). Each tour's steps/config live in its own file under ./tours.
export const tourRegistry: Record<string, TourConfig> = {
	canapps_navigation: canappsNavigationTour,
	canapps_add_user: canappsAddUserTour,
	canpark_manage_sites: canparkManageSitesTour,
	canpark_monitor_site: canparkMonitorSiteTour,
	canpark_register_plate: canparkRegisterPlateTour,
	canmeet_instant_meeting: canmeetInstantTour,
	canmeet_scheduled_meeting: canmeetScheduledTour,
	canpark_issue_ticket: canparkTicketingTour,
};

/** Whether a tour_key has step definitions wired up (i.e. is launchable). */
export const isTourRegistered = (tourKey: string): boolean =>
	Object.prototype.hasOwnProperty.call(tourRegistry, tourKey);

export const getTourConfig = (tourKey: string): TourConfig | undefined =>
	tourRegistry[tourKey];
